<div
  class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10"
  *transloco="let t; read: 'auth.confirmEmailChange'"
>
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />

  <div class="relative z-10 w-[640px] rounded-[5px] bg-white p-8">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
          <svg class="h-6 w-6 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.confirming') }}</h2>
        <p class="mt-2 text-center text-sm text-gray-600">{{ t('description.confirming') }}</p>
      </div>
    }

    <!-- Success State (user not logged in: show message + login button; if logged in we redirect in component) -->
    @if (isSuccess) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.success') }}</h2>
        <p class="mt-4 text-center text-sm text-gray-600">{{ t('description.success') }}</p>
        <button type="button" routerLink="/auth/login" class="btn btn-primary mt-6 justify-center">
          {{ t('backToLogin') }}
        </button>
      </div>
    }

    <!-- Error State -->
    @if (errorMessage) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <svg class="text-signal-error h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.error') }}</h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          {{ errorMessage }}
        </p>
        <button type="button" routerLink="/auth/login" class="btn btn-primary mt-6 justify-center">
          {{ t('backToLogin') }}
        </button>
      </div>
    }
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
